export default {
  hashtag: '#{text}',
  agesTag: '{min} a {max} años',
  copyFolderInfo: 'Haz click para guardar una copia en tus carpetas personales'
}

export const en = {
  hashtag: '#{text}',
  agesTag: '{min} to {max} y/o',
  copyFolderInfo: 'Click to save a copy in your personal folders'
}

export const ca = {
  hashtag: '#{text}',
  agesTag: '{min} a {max} anys',
  copyFolderInfo: 'Fes clic per desar una còpia a les teves carpetes personals'
}
